module.exports = __webpack_public_path__ + "static/img/1_0026.e07db25.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tech/1_0026.jpg
// module id = wodE
// module chunks = 0